import React from "react";
import SavedView from "./SavedView/SavedView";
import { apolloClient } from "../../..";
import { notify } from "../../Notify/Notify";
import { DELETE_SAVED_VIEWS_QUERY, FETCH_SAVED_VIEWS_QUERY } from "./Queries";
import { useParams } from "react-router-dom";
import EmptyViewsIcon from "../../../assets/EmptyStates/empty_views.svg";

// Styles
import "./SavedViews.scss";
import DeleteModal from "../../DeleteModal/DeleteModal";

const SavedViews = ({ setShowListDropdown, setShowAddDropdown, handleSavedViewSelect, selectedView }) => {
  const [views, setViews] = React.useState([]);
  const [showDeleteModal, setShowDeleteModal] = React.useState({ id: null, status: false, title: "" });
  let params = useParams();

  React.useEffect(() => {
    const variables = {
      folderId: params.folderId,
    };
    apolloClient
      .query({
        query: FETCH_SAVED_VIEWS_QUERY,
        variables: variables,
      })
      .then((result) => {
        const views = result.data.listSavedViews.map((view) => {
          return { ...view, columns: JSON.parse(view.columns), selected: false };
        });
        setViews(views);
      })
      .catch((e) => {
        const title = "Error";
        const detail = "oops! Something went wrong";
        const type = "error";
        notify(title, detail, type);
      });
  }, [params.folderId]);

  //Update selected view if user updates
  React.useEffect(() => {
    setViews((views) => {
      if (selectedView) {
        const { id } = selectedView;
        const index = views.findIndex((view) => view.id === id);
        if (index === -1) {
          views.push({ ...selectedView, selected: true });
        }
        return views.map((view) => {
          if (view.id === id) {
            return { ...view, ...selectedView };
          } else {
            return { ...view, selected: false };
          }
        });
      } else {
        return views;
      }
    });
  }, [selectedView]);

  const handleClick = ({ id, columns, title }) => {
    handleSavedViewSelect({ id, columns, title });
    setViews((views) => {
      return views.map((view) => {
        return { ...view, selected: view.id === id };
      });
    });
  };

  const handleDelete = () => {
    const { id } = showDeleteModal;
    const variables = {
      savedViewId: id,
    };
    apolloClient
      .query({
        query: DELETE_SAVED_VIEWS_QUERY,
        variables: variables,
      })
      .then((result) => {
        if (result.data.deleteSavedViews) {
          // Remove from the list
          setViews((views) => views.filter((view) => view.id !== id));
          handleSavedViewSelect(null);

          const detail = "Success";
          const title = `View deleted successfully`;
          const type = "success";
          notify(detail, title, type);
        }
      })
      .catch((e) => {
        const title = "Error";
        const detail = "oops! Something went wrong";
        const type = "error";
        notify(title, detail, type);
      })
      .finally(() => {
        setShowDeleteModal({ id: null, status: false });
      });
  };

  return (
    <div className="saved-views">
      <DeleteModal
        title="Delete Saved View"
        description={
          <>
            Are you sure you want to delete <b style={{ marginLeft: 4 }}>{showDeleteModal.title}?</b>
          </>
        }
        show={showDeleteModal.status}
        handleClose={() => setShowDeleteModal({ status: false, id: null, title: "" })}
        handleDelete={handleDelete}
      />
      <div className="header">
        <span className="title">Saved Views</span>
        <div
          className="action"
          onClick={() => {
            setShowAddDropdown(true);
            setShowListDropdown(false);
          }}
        >
          + Add View
        </div>
      </div>
      <div className="body">
        {views.map(({ title, id, selected, columns }) => (
          <SavedView key={id} {...{ title, handleClick, id, selected, columns, setShowDeleteModal }} />
        ))}
      </div>
      {views.length === 0 ? (
        <div className="empty-view">
          <img src={EmptyViewsIcon} alt="Add a saved view!" width="104" height="104" />
          <span className="title">Add a saved view!</span>
        </div>
      ) : null}
    </div>
  );
};

export default SavedViews;
